import { render, staticRenderFns } from "./canvas-item.vue?vue&type=template&id=89b3d344&scoped=true&"
import script from "./canvas-item.vue?vue&type=script&lang=js&"
export * from "./canvas-item.vue?vue&type=script&lang=js&"
import style0 from "./canvas-item.vue?vue&type=style&index=0&id=89b3d344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b3d344",
  null
  
)

export default component.exports